import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

const SUPPORTED_DOB_FORMATS = [
  "DD/MM/YYYY",
  "D/M/YYYY",
  "DD-MM-YYYY",
  "D-M-YYYY",
  "YYYY-MM-DD",
  "YYYY/MM/DD",
];

const REQUIRED_MESSAGE = {
  title: "Please select title",
  firstName: "Please enter first name",
  lastName: "Please enter last name",
  gender: "Please select gender",
  skills: "Please select skills",
  postCode: "Please enter postcode",
  mobile: "Please enter a mobile number",
  email: "Please enter email address",
  setting: "Select Candidate Setting",
  role: "Please select candidate role",
  dateOfBirth: "Please select DOB",
  band: "Please select band",
  referral: "Please select Referral",
  address: "Please enter address",
  gmcNumber: "Please enter GMC / NMC / HCPC number",
};

const isBlank = (value) =>
  value === null || value === undefined || String(value).trim() === "";

const parseDate = (value) => {
  if (!value) return null;
  const parsedDate = dayjs(String(value).trim(), SUPPORTED_DOB_FORMATS, true);
  if (parsedDate.isValid()) return parsedDate;

  const fallbackDate = dayjs(value);
  return fallbackDate.isValid() ? fallbackDate : null;
};

const isValidUKPostcode = (value) =>
  /^[A-Z]{1,2}\d[A-Z\d]?\s*\d[A-Z]{2}$/i.test(String(value).trim());

const hasValidNameCharacters = (value) =>
  /^[A-Za-z0-9]+(?:[ '-][A-Za-z0-9]+)*$/.test(String(value).trim());

const isValidPhoneNumber = (value) => /^\d+$/.test(String(value).trim());

export const validateCandidatePersonalForm = (values = {}) => {
  const errors = {};

  if (isBlank(values.title)) errors.title = REQUIRED_MESSAGE.title;

  if (isBlank(values.firstName)) {
    errors.firstName = REQUIRED_MESSAGE.firstName;
  } else if (!hasValidNameCharacters(values.firstName)) {
    errors.firstName = "first name should not accept any special characters";
  }

  if (isBlank(values.lastName)) {
    errors.lastName = REQUIRED_MESSAGE.lastName;
  } else if (!hasValidNameCharacters(values.lastName)) {
    errors.lastName = "last name should not accept any special characters";
  }

  if (isBlank(values.gender)) errors.gender = REQUIRED_MESSAGE.gender;
  if (values.hasSkills) {
    if (!Array.isArray(values.skills) || values.skills.length === 0) {
      errors.skills = REQUIRED_MESSAGE.skills;
    }
  }
  if (isBlank(values.setting)) errors.setting = REQUIRED_MESSAGE.setting;
  if (isBlank(values.role)) errors.role = REQUIRED_MESSAGE.role;
  if (isBlank(values.band)) errors.band = REQUIRED_MESSAGE.band;
  if (isBlank(values.referral)) errors.referral = REQUIRED_MESSAGE.referral;
  if (isBlank(values.address)) errors.address = REQUIRED_MESSAGE.address;
  if (isBlank(values.gmcNumber)) errors.gmcNumber = REQUIRED_MESSAGE.gmcNumber;

  if (isBlank(values.postCode)) {
    errors.postCode = REQUIRED_MESSAGE.postCode;
  } else if (!isValidUKPostcode(values.postCode)) {
    errors.postCode = "Please enter only UK postcode";
  }

  if (isBlank(values.mobile)) {
    errors.mobile = REQUIRED_MESSAGE.mobile;
  } else if (!isValidPhoneNumber(values.mobile)) {
    errors.mobile = "Please enter a valid number";
  } else if (String(values.mobile).trim().length < 10) {
    errors.mobile = "Please enter minimum 10 digit in mobile number";
  } else if (String(values.mobile).trim().length > 13) {
    errors.mobile = "Please enter maximum 13 digit in mobile number";
  }

  if (isBlank(values.email)) errors.email = REQUIRED_MESSAGE.email;

  if (isBlank(values.dateOfBirth)) {
    errors.dateOfBirth = REQUIRED_MESSAGE.dateOfBirth;
  } else {
    const dob = parseDate(values.dateOfBirth);
    if (!dob || !dob.isValid() || dayjs().diff(dob, "year") < 16) {
      errors.dateOfBirth = "Age must be more than or equals to 16 years old";
    }
  }

  return errors;
};
